"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
/* eslint-disable no-useless-escape */

var validEmail = function validEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};
var validDate = function validDate(date) {
  // eslint-disable-next-line
  return !isNaN(Date.parse(date));
};
var validCustom = function validCustom(customValue, customRegEx) {
  return customRegEx.test(customValue);
};

//Formating phone number value to prevent event.target.value to escape NumberFormat component formating
var formatPhoneNumber = function formatPhoneNumber(val) {
  return val.match(/\d/g).join('');
};
var useFormElementValidation = function useFormElementValidation(initialValue, options) {
  var _useState = (0, _react.useState)({}),
    errors = _useState[0],
    setErrors = _useState[1];
  var _options$customMessag = options.customMessage,
    cMsg = _options$customMessag === void 0 ? {} : _options$customMessag;
  var checkErrors = function checkErrors(valueToTest) {
    var newErrors = [];
    if (options.required && typeof valueToTest === 'boolean' && !valueToTest) {
      cMsg.hasOwnProperty('required') ? newErrors.push(cMsg.required) : newErrors.push('This field is required');
    } else {
      if (options.required && (!valueToTest || valueToTest && valueToTest.length === 0)) {
        cMsg.hasOwnProperty('required') ? newErrors.push(cMsg.required) : newErrors.push('This field is required');
      }
      if (options.required && options.currency && valueToTest && +valueToTest === 0) {
        cMsg.hasOwnProperty('currency') ? newErrors.push(cMsg.currency) : newErrors.push('This field cannot be 0');
      }
      if (options.date && valueToTest && !validDate(valueToTest)) {
        cMsg.hasOwnProperty('date') ? newErrors.push(cMsg.date) : newErrors.push('Please enter a valid date');
      }
      if (options.email && valueToTest && !validEmail(valueToTest)) {
        cMsg.hasOwnProperty('email') ? newErrors.push(cMsg.email) : newErrors.push('Please enter a valid email');
      }
      if (options.number && valueToTest && options.max < +valueToTest) {
        cMsg.hasOwnProperty('number') ? newErrors.push(cMsg.number) : newErrors.push("Too much, max " + options.max);
      }
      if (options.number && valueToTest && options.min > +valueToTest) {
        cMsg.hasOwnProperty('number') ? newErrors.push(cMsg.number) : newErrors.push("Not enough, min " + options.min);
      }
      if (options.maxChar && valueToTest && valueToTest.length > options.maxChar) {
        cMsg.hasOwnProperty('maxChar') ? newErrors.push(cMsg.maxChar) : newErrors.push("Please type at most " + options.maxChar + " characters");
      }
      if (options.atLeast && valueToTest && valueToTest.length < options.atLeast) {
        cMsg.hasOwnProperty('atLeast') ? newErrors.push(cMsg.atLeast) : newErrors.push("Please choose at least " + options.atLeast + " options");
      }
      if (options.atMost && valueToTest && valueToTest.length > options.atMost) {
        cMsg.hasOwnProperty('atMost') ? newErrors.push(cMsg.atMost) : newErrors.push("Please choose at most " + options.atMost + " options");
      }
      if (options.tel && valueToTest && formatPhoneNumber(valueToTest).length < 10) {
        cMsg.hasOwnProperty('tel') ? newErrors.push(cMsg.tel) : newErrors.push("Please enter a valid phone number. " + (10 - valueToTest.length) + " numbers left");
      }
      if (options.customValidation && valueToTest && !validCustom(valueToTest, options.customValidation)) {
        cMsg.hasOwnProperty('customValidation') ? newErrors.push(cMsg.customValidation) : newErrors.push('This field does not match expectations');
      }
      if (options.customInvalidation && valueToTest && validCustom(valueToTest, options.customInvalidation)) {
        cMsg.hasOwnProperty('customInvalidation') ? newErrors.push(cMsg.customInvalidation) : newErrors.push('This field does not match expectations');
      }
      if (options.booleanValidation !== undefined && valueToTest && !options.booleanValidation) {
        cMsg.hasOwnProperty('booleanValidation') ? newErrors.push(cMsg.booleanValidation) : newErrors.push('This field does not match expectations');
      }
    }
    setErrors(newErrors);
  };
  var handleDateChange = function handleDateChange(date) {
    return checkErrors(date);
  };
  var handleChangeRadioGroup = function handleChangeRadioGroup(id, RadioGroupOptions) {
    var radioChecked = RadioGroupOptions.filter(function (radio) {
      return id === radio.id;
    });
    checkErrors(radioChecked.length ? radioChecked[0].value : undefined);
  };
  var handleChangeCheckboxGroup = function handleChangeCheckboxGroup(CheckboxGroupChecked) {
    return checkErrors(CheckboxGroupChecked);
  };
  var handleValueChange = function handleValueChange(event) {
    var val = event && event.target ? event.target.value // when an event is passed
    : event; // when it's the value itself that is passed
    checkErrors(val);
  };
  var handleCheck = function handleCheck(event) {
    event.persist();
    checkErrors(event.target.checked);
  };
  var handleInput = function handleInput(event) {
    return errors.length && checkErrors(event.target.value);
  };
  return [
  // returnedValue,
  errors, {
    onChange: handleValueChange,
    onInput: handleInput,
    onClick: handleCheck,
    onSelect: handleValueChange,
    onBlur: handleValueChange,
    onChangeCheckbox: handleCheck,
    onChangeCheckboxGroup: handleChangeCheckboxGroup,
    onChangeRadio: handleCheck,
    onChangeRadioGroup: handleChangeRadioGroup,
    onChangeDate: handleDateChange
  }];
};
var _default = exports.default = useFormElementValidation;